const LANGUAGE_SWITCHER_PORTAL_ID = "language-switcher-portal";

export default LANGUAGE_SWITCHER_PORTAL_ID;
